<script setup>
import {ref, watch} from 'vue'
import {usePagePathStore} from '@/stores/pagePath'
import {usePageContentDataStore} from '@/stores/pageContentData'

const props = defineProps({
    pageId: Number,
    pageContentId: Number,
    suffix: String
})

const pagePathStore = usePagePathStore()
const pageContentDataStore = usePageContentDataStore()

// --- State ---

const path = ref('')

// --- Methods ---

const resolvePath = async () => {
    // 1. Basic validation
    if (!props.pageId && !props.pageContentId) {
        path.value = ''
        return
    }

    let targetPageId = props.pageId

    // 2. If contentId is provided, look up its parent pageId first
    if (props.pageContentId) {
        const contentItem = pageContentDataStore.items.find(
            (obj) => obj.id === props.pageContentId
        )

        if (contentItem) {
            targetPageId = contentItem.pageId
        }
    }

    // 3. Dispatch the path lookup via Pinia store
    if (targetPageId) {
        pagePathStore.suffix = props.suffix || ''

        const result = await pagePathStore.get({pageId: targetPageId})

        // Append content anchor if applicable
        path.value = props.pageContentId
            ? `${result}#${props.pageContentId}`
            : result
    }
}

// --- Watcher ---

// Re-run the path resolution whenever IDs change
watch(
    () => [props.pageId, props.pageContentId, props.suffix],
    resolvePath,
    {immediate: true}
)
</script>

<template>
    <code v-if="path">{{ path }}</code>
</template>

<style scoped>
/* Standard styling for the <code> block to keep paths readable */
code {
    word-break: break-all;
}
</style>